import React, { useState, useEffect } from "react";

function Countdown({ targetDate }) {
  const calculateTimeLeft = () => {
    // console.log(targetDate);
    const difference = new Date(targetDate) - new Date();
    // console.log(difference)
    let timeLeft = {};

    // console.log(difference)
    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      };
    }

    return timeLeft;
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearTimeout(timer);
  });

  const timerComponents = [];

  Object.keys(timeLeft).forEach((interval) => {
    if (!timeLeft[interval]) {
      return;
    }

    timerComponents.push(
      <span key={interval}>
        {timeLeft[interval]} {interval}{" "}
      </span>
    );
  });

  return (
    <div style={{fontSize: '20px'}}>
      {timerComponents.length ? (
        timerComponents
      ) : (
        <span>Countdown Complete!</span>
      )}
    </div>
  );
}

export default Countdown;
